import { useEffect, useState } from 'react'
import { CuentaContraparte } from '../types/types'
import { HttpContraparte } from '../api/httpContraparte'
import { QueryStatus } from 'src/types'

export const useCuentas = (idOperacion: number) => {
    const [cuentas, setCuentas] = useState<CuentaContraparte[]>()
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)

    const fetch = () => {
        setStatus(QueryStatus.Loading)

        HttpContraparte.getCuentas(idOperacion)
            .then(value => {
                setCuentas(value)
                setStatus(QueryStatus.Success)
            })
            .catch(e => {
                setStatus(QueryStatus.Error)
                console.log(e)
            })
    }

    const refetch = () => fetch()

    useEffect(() => {
        fetch()
    }, [idOperacion])

    return { cuentas, refetch, status }
}
